import pug from 'javascripts/search/templates/user_result.jst.pug';
window.JST = window.JST || {};
window.JST['search/templates/user_result'] = pug;
